import { FaStar, FaUsers, FaTicket } from 'react-icons/fa6';

const pricing = [
    {
        id: 1,
        icon: <FaTicket />, // Ticket icon
        title: 'General Admission',
        price: 29.99,
        features: [
            'Access to All Sessions',
            'Conference Materials',
            'Networking Opportunities',
            'Free Refreshments',
            'No Hidden Fees',
        ],
    },
    {
        id: 2,
        icon: <FaStar />, // Star icon for VIP
        title: 'VIP Admission',
        price: 99.99,
        features: [
            'General Admission Benefits',
            'Priority Seating',
            'Exclusive Networking Event',
            'Meet & Greet with Speakers',
            'Special VIP Lounge Access',
        ],
    },
    {
        id: 3,
        icon: <FaUsers />, // Users icon for group
        title: 'Group Admission',
        price: 199.99,
        features: [
            'Access for Up to 5 People',
            'Group Discount Available',
            'Conference Materials',
            'Networking Opportunities',
            'No Hidden Fees',
        ],
    },
];

export default pricing;